<template>
  <div>
    <div class="highlight--stats">
      <span class="stats--title">
        {{ title }}
        <i class="fal fa-info-circle" :id="id"></i>
        <b-popover :target="id" triggers="hover" placement="top">
          <!-- <template #title>{{ title }}</template> -->
          {{ description }}
        </b-popover>
      </span>
      <div class="value--unit">
        <span class="stats--value">{{ value }}</span>
        <span class="stats--unit col-md-0 col-sm-0 col-xs-0" v-if="!mobile">{{ unit }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["id", "title", "description", "value", "unit"],
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.highlight--stats {
  background-color: white;
  border-radius: 8px;
  /* box-shadow: 0px 3px 10px #0000000F; */
  /* padding: 30px 20px; */

  display: flex;
  flex-direction: column;
  /* align-items: center; */
  justify-content: center;
}

.value--unit {
  display: flex;
  flex-direction: row;
  /* justify-content: center; */
  align-items: flex-end;
}

.stats--title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

.stats--value {
  font-size: 40px;
  font-weight: bold;
  color: #545454;
}

.stats--unit {
  font-size: 14px;
  font-weight: 500;
  color: #d1d1d1;
  padding: 0 0 10px 10px;
}
</style>
